import "../styles/ApprovedBanks.css";
import { motion } from "framer-motion";


import pnb from "../assets/serene-images/banks/PNB.png";
import icici from "../assets/serene-images/banks/small_Tata_Capital_Housing_Finan.png";
import indiabulls from "../assets/serene-images/banks/aditya-birla-capital-vector-logo.png";
import kvb from "../assets/serene-images/banks/HDFC.png";
import hdfc from "../assets/serene-images/banks/ICICI.png";
import aditya from "../assets/serene-images/banks/indiabulls.png";
import karur from "../assets/serene-images/banks/karur-vysya.png";

const banks = [pnb, icici, indiabulls, kvb, hdfc, aditya, karur];
// Duplicate for seamless loop
const marqueeBanks = [...banks, ...banks, ...banks]; // Tripling just to be safe on wide screens

// Animation for the text (kept from previous version)
const wordContainer = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.12,
            delayChildren: 0.15,
        },
    },
};

const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
        y: 0,
        opacity: 1,
        filter: "blur(0px)",
        transition: { duration: 0.8, ease: "easeOut" },
    },
};

const fadeUp = {
    hidden: { opacity: 0, y: 30, filter: "blur(5px)" },
    show: {
        opacity: 1, y: 0, filter: "blur(0px)",
        transition: { duration: 0.8, delay: 0.4 }
    },
};

const line1 = "Trusted Financing from".split(" ");
const line2 = "Leading Banks".split(" ");

export default function ApprovedBanks() {
    return (
        <section className="approved-banks-section">
            <div className="container">
                {/* HEADLINE AREA */}
                <div className="text-center mb-5">
                    {/* <span className="banks-eyebrow">Financial Partners</span> */}

                    <motion.h2
                        className="approved-banks-title display-4"
                        variants={wordContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        {line1.map((word, i) => (
                            <motion.span
                                key={`line1-${i}`}
                                variants={wordVariant}
                                style={{ display: "inline-block", marginRight: "0.25em" }}
                            >
                                {word}
                            </motion.span>
                        ))}
                        <br className="d-none d-md-block" />
                        {line2.map((word, i) => (
                            <motion.span
                                key={`line2-${i}`}
                                variants={wordVariant}
                                style={{ display: "inline-block", marginRight: "0.25em" }}
                            >
                                {word}
                            </motion.span>
                        ))}
                    </motion.h2>

                    <motion.p
                        className="about-text mx-auto mt-3"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                    >
                        We have partnered with the nation's leading financial institutions to facilitate
                        hassle-free home loans and exclusive offers for our customers.
                    </motion.p>
                </div>

                {/* INFINITE MARQUEE */}
                {/* We use a mask in CSS, and here we slide the track */}
                <div className="marquee-wrapper">
                    <motion.div
                        className="marquee-track"
                        animate={{ x: ["0%", "-33.33%"] }} // Move 1/3 since we tripled the list
                        transition={{
                            duration: 30,
                            ease: "linear",
                            repeat: Infinity
                        }}
                    >
                        {marqueeBanks.map((logo, index) => (
                            <div className="bank-card-premium" key={index}>
                                <img src={logo} alt="Bank Logo" />
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
}


